import request from '@/utils/request'
/**
 *
 * 咨询师管理
 *
 **/
// 登录
export const login = (data: any) =>
  request({
    'url': '/consultant/login',
    'method': 'post',
    data: data
  })

  // 退出
 export const userLogout = (params: any) =>
 request({
   'url': `/consultant/logout`,
   'method': 'post',
   params
 })

// 分页查询
export const getConsultantList = (params: any) =>
request({
    'url': `/consultant/page`,
    'method': 'get',
    'params': params
})

// 启用禁用咨询师账号
export const enableOrDisableConsultant = (params: any) =>
request({
  'url': `/consultant/status/${params.status}`,
  'method': 'POST',
  'params': {id: params.id}
})

// 新增咨询师
export const addConsultant = (params: any) =>
request({
  'url': '/consultant',
  'method': 'POST',
  'data': params
})

// 根据id查询咨询师
export const queryConsultantById = (id: number) =>
request({
  'url': `/consultant/${id}`,
  'method': 'GET'
})

// 修改咨询师
export const updateConsultant = (params: any) =>
request({
  'url': '/consultant',
  'method': 'PUT',
  'data': params
})

// 重置咨询师
export const ResetConsultant = (id: number) =>
  request({
    'url': `/consultant/reset/${id}`,
    'method': 'PUT',
    // 'data': params
  })